import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetDepartment, useUpdateDepartment } from "@/hooks/departments";
import { CreateDepartment, Department } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute(
  "/(departments)/departments/_sheet/$id/edit",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetDepartment(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Department }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateDepartment({
    onSuccess: (department) => {
      navigate({
        to: "/departments",
        params: { id: department.id.toString() },
      });
    },
  });

  const update = async (department: CreateDepartment) => {
    await mutateAsync({ id: model.id, ...department });
  };
  return <Form model={model} onUpsert={update} />;
}
